import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GameModeService } from '../../_services/game-mode.service';
import { GamePhase } from '../../interfaces/game-state.interface';
import { ClassCreature } from '../../interfaces/creature.interface';
import { getDailyBonusTopic } from '../../data/league-config';
import { DailyBonus } from '../../interfaces/score.interface';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-game-hub',
  templateUrl: './game-hub.component.html',
  styleUrls: ['./game-hub.component.scss']
})
export class GameHubComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  creature: ClassCreature | null = null;
  dailyBonus: DailyBonus;
  currLang: any = 'en';

  constructor(
    private gameModeService: GameModeService,
    private globalService: GlobalService
  ) {
    this.dailyBonus = getDailyBonusTopic();
  }

  ngOnInit(): void {
    this.gameModeService.creature$
      .pipe(takeUntil(this.destroy$))
      .subscribe(c => this.creature = c);

    this.globalService.getLang()
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => this.currLang = lang);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openQuiz(): void {
    this.gameModeService.setPhase(GamePhase.SUBJECT_PICK);
  }

  openCreatureProfile(): void {
    this.gameModeService.setPhase(GamePhase.CREATURE_PROFILE);
  }

  openMap(): void {
    this.gameModeService.setPhase(GamePhase.MAP);
  }

  getDailyBonusLabel(): string {
    return this.currLang === 'ar' ? this.dailyBonus.label.ar : this.dailyBonus.label.en;
  }

  getRyderWelcome(): string {
    // Phase 1: Generic welcome (no creature references)
    return this.currLang === 'ar'
      ? 'مرحباً! أنا رايدر. هيا نبدأ المغامرة!'
      : 'Hey there! I\'m Ryder. Let\'s start the adventure!';

    /* Phase 2: Creature-aware welcome messages
    if (!this.creature) {
      return this.currLang === 'ar'
        ? 'مرحباً! أنا رايدر. اختر مخلوقك وابدأ المغامرة!'
        : 'Hey there! I\'m Ryder. Pick your creature and let\'s start the adventure!';
    }
    const name = this.creature.customName;
    const streak = this.creature.currentStreak;
    if (streak >= 5) {
      return this.currLang === 'ar'
        ? `${name} في سلسلة رائعة! هيا نكمل!`
        : `${name} is on fire! Let's keep the streak going!`;
    }
    return this.currLang === 'ar'
      ? `مرحباً مجدداً! ${name} جاهز للتحدي!`
      : `Welcome back! ${name} is ready for a challenge!`;
    */
  }
}
